import { StatusIndicator } from '@amzn/awsui-components-core';
import { CodeRepoReviewStatus } from '@amzn/awscat-pattern-library-service-model';

/** Status indicator for a code repository's review status, shared by the edit and read-only Code tabs. */
export function CodeRepoStatusBadge({ status }: { readonly status: CodeRepoReviewStatus }) {
  switch (status) {
    case CodeRepoReviewStatus.ResolvedSuccessful:
      return <StatusIndicator type="success">Resolved Successful</StatusIndicator>;
    case CodeRepoReviewStatus.ResolvedUnsuccessful:
      return <StatusIndicator type="error">Resolved Unsuccessful</StatusIndicator>;
    case CodeRepoReviewStatus.InProgress:
      return <StatusIndicator type="in-progress">In Progress</StatusIndicator>;
    default:
      return <StatusIndicator type="pending">Not Started</StatusIndicator>;
  }
}
